import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  {
    id: "32e2d003-9601-4206-9aae-c876563cd424",
    content: "Room acoustics ",
    options: {},
  },
  {
    id: "85ed765c-efe2-407c-a9b6-8da8a2a2da0b",
    content: "Building acoustics",
    options: {},
  },
  {
    id: "a9bdf0fc-ee4a-4804-895b-2c7ae81dff8d",
    content: "Electro acoustics",
    options: {},
  },
  {
    id: "12761abb-c345-4393-9823-0f97be8d11ee",
    content: "Architectural acoustics",
    options: {},
  },
  {
    id: "75035d76-d650-4921-94a6-03ff9efafcc7",
    content: "Bio acoustics",
    options: {},
  },
  {
    id: "3b298b27-04ad-405e-b7bd-34c4d6f0f933",
    content: "Theater acoustics",
    options: {},
  },
];

export const task: Task = {
  id: "8b66a56f-3556-4588-8588-01b9fe5d2bfe",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: false,
    shuffle: true,
    columns: 2,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["85ed765c-efe2-407c-a9b6-8da8a2a2da0b"],
};
